import { useInstance } from "@meraki-internal/react-dependency-injection";
import { ClubState, IVolunteerMediaType } from "../clubs/ClubsState";
import { IonBadge, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle } from "@ionic/react";
import { Image } from "./Image";
import { VolunteerModalState } from "./VolunteerList";
import { useState } from "react";

const DeleteButton: React.FC<{ onClick: () => Promise<void>; children: React.ReactNode; }> =  ({ onClick, children }) => {
    const [ state, setState ] = useState({
        isConfirming: false,
        isDeleting: false
    });

    const onStartDelete = () => {
        setState({
            isConfirming: true,
            isDeleting: false
        });
    }

    const onCancel = () => {
        setState({
            isConfirming: false,
            isDeleting: false
        });
    }

    const onConfirm = async () => {
        try {
            setState({
                isConfirming: false,
                isDeleting: true
            });

            await onClick();
        }
        finally{
            setState({
                isConfirming: false,
                isDeleting: false
            });
        }
    }

    if (!state.isConfirming && !state.isDeleting){
        return (
            <IonButton onClick={onStartDelete}>{children}</IonButton>
        );
    }
    if (state.isConfirming){
        return (
            <>
                <IonButton onClick={onCancel}>Cancel</IonButton>
                <IonButton onClick={onConfirm} color="danger">Confirm</IonButton>
            </>
        )
    }
    if (state.isDeleting){
        return (
            <>
                <IonButton disabled>{children}</IonButton>
            </>
        )
    }
    return null;
}

export const badgeEligibleTitles = ['Vex Event Partner', 'Vex Judge Advisor', 'Vex Head Referee'];

export const titleHelper = (titles: string[]) => {
    return {
        badges: badgeEligibleTitles.filter(badge => titles.includes(badge)),
        titles: titles.filter(title => !badgeEligibleTitles.includes(title))
    }
}

export const VolunteerCard: React.FC<{ volunteer: IVolunteerMediaType;  }> = ({ volunteer }) => {
    const clubState = useInstance(ClubState);
    const modal = useInstance(VolunteerModalState);

    const { name, imagePath, titles, isClubAdmin, email } = volunteer;

    const deleteVolunteer = async () => {
        await clubState.deleteVolunteer(volunteer);
    }

    const editVolunteer = () => {
        modal.open(volunteer);
    }

    const splitTitles = titleHelper(titles);

    // use titles...
    return (
        <IonCard style={{ width: 300}}>
            <IonCardHeader>
                <IonCardTitle>{name}</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
                <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: 3, left: 3, display: 'flex', flexDirection: 'column', gap: 5}}>
                        {isClubAdmin && (
                            <IonBadge>Club Admin</IonBadge>
                        )}
                        {splitTitles.badges.map(badge => (
                            <IonBadge key={badge}>{badge}</IonBadge>
                        ))}
                    </div>


                    <Image src={imagePath} />
                </div>
                {email && (
                    // TODO: email component, that also makes it easy to email them, or copy it
                    <div>{email}</div>
                )}

                <ul id="volunteer-list">
                    {splitTitles.titles.map((title, i) => (
                        <li key={i}>
                            {title}
                        </li>
                    ))}
                </ul>
            </IonCardContent>
            <IonButtons>
                <DeleteButton onClick={deleteVolunteer}>Delete</DeleteButton>
                <IonButton onClick={editVolunteer}>Edit</IonButton>
            </IonButtons>
        </IonCard>
    )
}